import { registerElementErrorsSideEffect } from './Element/errors'
import { registerJavaScriptErrorsSideEffect } from './JavaScript/errors'
import { registerMustacheErrorsSideEffect } from './Mustache/errors'

export function sideEffect() {
  registerElementErrorsSideEffect()
  registerJavaScriptErrorsSideEffect()
  registerMustacheErrorsSideEffect()
}
